import { ActionIcon, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useState } from "react";
import { copyMarkdownToClipboard } from "../utils/copyToClipboard";

interface CopyToClipboardButtonProps {
    content: string;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    variant?: "subtle" | "light" | "filled" | "outline" | "default" | "transparent";
    color?: string;
    disabled?: boolean;
    className?: string;
}

export const CopyToClipboardButton = ({
    content,
    size = "sm",
    variant = "subtle",
    color = "gray",
    disabled = false,
    className,
}: CopyToClipboardButtonProps) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!content || disabled) return;

        try {
            await copyMarkdownToClipboard(content);
            setCopied(true);

            // Reset copied state after 2 seconds
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error("Failed to copy content:", error);
        }
    };

    return (
        <Tooltip
            label={copied ? "Copied to clipboard!" : "Copy to clipboard"}
            position="top"
            withArrow
        >
            <ActionIcon
                size={size}
                variant={variant}
                color={copied ? "green" : color}
                onClick={handleCopy}
                disabled={disabled || !content}
                className={className}
                aria-label="Copy to clipboard"
            >
                {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
            </ActionIcon>
        </Tooltip>
    );
};
